import {
  REQUEST_EMAIL_PREFERENCES,
  REQUEST_EMAIL_PREFERENCES_SUCCESS,
  REQUEST_EMAIL_PREFERENCES_FAIL,
  UPDATE_EMAIL_PREPREFERENCES,
  UPDATE_EMAIL_PREPREFERENCES_FAIL,
} from './actionTypes';
import { getInitialValueFromStorage } from '../../helpers';

export const initialState = () => ({
  emailPreferences: getInitialValueFromStorage('emailPreferences', {}),
});

export const emailPreferencesReducer = (state, action) => {
  switch (action.type) {
    case REQUEST_EMAIL_PREFERENCES:
      return {
        ...state,
        emailPreferences: { ...state.emailPreferences, loading: true, fail: false },
      };
    case REQUEST_EMAIL_PREFERENCES_SUCCESS:
      return {
        ...state,
        emailPreferences: { data: action.payload, loading: false, fail: false },
      };
    case REQUEST_EMAIL_PREFERENCES_FAIL:
      return {
        ...state,
        emailPreferences: { ...state.emailPreferences, loading: false, fail: true },
      };
    case UPDATE_EMAIL_PREPREFERENCES:
      return {
        ...state,
        emailPreferences: {
          ...state.emailPreferences,
          data: {
            optionEmailPreferences: action.payload,
          },
          loading: false,
          fail: false,
        },
      };
    default:
      return state;
  }
};

export const actions = {
  getEmailPreferences: () => ({ type: REQUEST_EMAIL_PREFERENCES }),
  getEmailPreferencesSuccess: (data) => ({
    type: REQUEST_EMAIL_PREFERENCES_SUCCESS,
    payload: data,
  }),
  getEmailPreferencesFail: (error) => ({ type: REQUEST_EMAIL_PREFERENCES_FAIL, payload: error }),
  updateEmailPreference: (value) => ({ type: UPDATE_EMAIL_PREPREFERENCES, payload: value }),
  updateEmailPreferencesFail: (error) => ({
    type: UPDATE_EMAIL_PREPREFERENCES_FAIL,
    payload: error,
  }),
};
